import React from 'react';
import clsx from 'clsx';
import {Theme} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog, {DialogProps} from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        '& .MuiDialog-paper': {
            overflow: 'visible',
            transformStyle: 'preserve-3d',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: theme.palette.secondary.main,
            borderRadius: 3,

            '&:after': {
                content: '""',
                display: 'block',
                width: '100%',
                height: '100%',
                borderRadius: 3,
                position: 'absolute',
                right: -5,
                bottom: -5,
                backgroundColor: theme.palette.secondary.main,
                opacity: 0.2,
                transform: 'translateZ(-1px)',
            },

            '&.MuiDialog-paperFullWidth': {
                [theme.breakpoints.down('xs')]: {
                    maxWidth: '100%',
                    width: '100%',
                    margin: theme.spacing(2.5),
                }
            },

            '& .MuiDialogTitle-root': {
                padding: theme.spacing(2),
                paddingBottom: 0,
            },

            '& .MuiDialogContent-root': {
                padding: theme.spacing(2),
                paddingTop: theme.spacing(1.5),
            },
        },
    },
    backdrop: {
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    closeButtonContainer: {
        textAlign: 'right',

        '& .MuiIconButton-sizeSmall': {
            marginTop: -3,
            marginRight: -3,
        },
    },
    bodyText: {
        fontSize: 16,
    },
}));

interface CustomDialogProps {
    title: string;
};

type Props = DialogProps & CustomDialogProps;

const BookingToolDialog = (props: Props) => {
    const classes = useStyles();
    const {children, className, title, onClose, ...remainingProps} = props;

    const dialogProps: DialogProps = {
        maxWidth: 'sm',
        fullWidth: true,
        scroll: 'paper',
        BackdropProps: {className: classes.backdrop},
        className: clsx([classes.root, className]),
        onClose,
        ...remainingProps,
    };

    return (
        <Dialog {...dialogProps}>
            <DialogTitle>
                <Grid container justify="space-between">
                    <Grid item xs={10}>
                        <Typography variant="body1" className={classes.bodyText}>
                            <strong>{title}</strong>
                        </Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.closeButtonContainer}>
                        <IconButton
                            size="small"
                            onClick={event => onClose && onClose(event, 'backdropClick')}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default BookingToolDialog;
